module.exports = __webpack_public_path__ + "src/assets/img/door_left_color.ee34c4ea.svg";